import z from "zod";

import { EventStatsPublic } from ".";
import { EventCategorySchema, EventSchema, LocationSchema, OrgSchema } from "../../models";

export const Select = {
  id: true,
  slug: true,
  title: true,
  description: true,
  banner: true,
  status: true,
  isPublic: true
} as const;

export const Schema = EventSchema.pick(Select).extend({
  host: OrgSchema.pick({
    id: true,
    name: true,
    avatar: true,
    slug: true,
    verified: true
  }),
  location: LocationSchema,
  category: EventCategorySchema.pick({
    id: true,
    name: true
  })
    .optional()
    .nullable(),
  stats: EventStatsPublic.Schema
});

export type Type = z.infer<typeof Schema>;
